import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QueryButton from "../common/querybutton";
import SuggestionContent from "../suggestion";
import "./maincontent.css";
import { FailureToast, SuccessToast } from "../../utils/commonunctions";
import { useDispatch, useSelector } from "react-redux";
import { submitQueryApi } from "../../redux/action/UserAction";
import { estimateCostApi } from "../../redux/action/UserAction";
import { userSelector } from "../../redux/slices/userSlice";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { CircularIndeterminate } from "../../utils/helperdata";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import { height, minHeight } from "@mui/system";

const MainContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // Extract values passed via navigation state
  const oldquery = location?.state?.oldq;
  const isModifyQuery = location?.state?.isModifyQuery;
  const oldOptions = location?.state?.options;
  const convoid = location?.state?.convoId;

  const groupID = sessionStorage.getItem("currentGrp");
  const { getGenerateQueryMessage } = useSelector(userSelector);

  const [cost, setCost] = useState(0);
  const [isEstimating, setIsEstimating] = useState(false);
  const [isCostEstimated, setIsCostEstimated] = useState(false); // NEW

  const [isGenerating, setIsGenerating] = useState(false); // loading state
  const [editGenerateQuery, seteditGenerateQuery] = useState(""); // editable query text
  const [isOption, setOptions] = useState(""); // store options used for query generation

  // Combine user inputs to generate a readable sentence
  const generateSentence = (values) => {
    const { subject, output, language, length, audience, ...otherFields } =
      values;
    setOptions(values);

    let sentence = `${output || ""} ${subject || ""}`.trim();

    if (language) sentence += ` in ${language}`;
    if (length) sentence += ` within ${length}`;
    if (audience) sentence += ` for ${audience}`;

    const otherDetails = Object.entries(otherFields)
      .map(([key, value]) => value)
      .join(" ");

    if (otherDetails) sentence += " " + otherDetails;

    return seteditGenerateQuery(sentence.trim() + ".");
  };

  // Set the existing query (in case of edit)
  useEffect(() => {
    seteditGenerateQuery(oldquery);
  }, []);

  // Reset when user changes query
  useEffect(() => {
    setIsCostEstimated(false);
  }, [editGenerateQuery]);

  // Copy generated query to clipboard
  const handleCopy = () => {
    if (!editGenerateQuery) {
      FailureToast("No Query to copy!");
      return;
    }

    navigator.clipboard
      .writeText(editGenerateQuery)
      .then(() => {
        SuccessToast(" Query Copied to clipboard!");
      })
      .catch((err) => { });
  };

  // Submit the query to the backend
  const submitQuery = async () => {
    if (editGenerateQuery) {
      dispatch(
        submitQueryApi(
          {
            query: editGenerateQuery,
            options: isOption,
            new_conversation: true,
          },
          setIsGenerating,
          navigate,
          groupID
        )
      );
    } else {
      setIsGenerating(false);
      // FailureToast("Please generate the query");
    }
  };

  // Estimate Cost
  const estimateCost = async () => {
    if (!editGenerateQuery || editGenerateQuery.trim() === "") {
      // FailureToast("Please generate the query");
      return;
    }

    setIsEstimating(true);

    try {
      dispatch(
        estimateCostApi(editGenerateQuery, (estimatedCost) => {
          setCost(estimatedCost);
          setIsCostEstimated(true);
        })
      );

      setIsEstimating(false);
    } catch (err) {
      console.error("Error estimating cost:", err);
      setIsEstimating(false);
    }
  };

  return (
    <div className="maincontentcontainer">
      {/* Header and Back Navigation */}
      <div style={{ width: "100%", display: "flex-end", minHeight: "100px" }}>
        <div className="empty-div"></div>
        <div className="content-wrapper">
          <p className="maincontenthead">Query Construction</p>

          {isModifyQuery ? (
            <div
              className="back-btn"
              onClick={() => {
                navigate("/response", {
                  state: { id: convoid, isHistory: true },
                });
              }}
            >
              Back to Response <ArrowForwardIcon />
            </div>
          ) : null}
        </div>
      </div>

      {/* Dynamic query input section */}
      <SuggestionContent
        generateSentence={generateSentence}
        seteditGenerateQuery={seteditGenerateQuery}
        oldOptions={oldOptions}
        isModifyQuery={isModifyQuery}
        setOptions={setOptions}
      />
      <div style={{ minHeight: "50px" }}>

      </div>

      {/* estimate cost */}
      {/* <Grid
        container
        justifyContent="flex-end"
        alignItems="center"
        spacing={2}
        style={{ width: "100%", marginBottom: "10px" }}
      >
        {
          <Grid item>
            <QueryButton
              btntext={"Estimate Cost"}
              isDisabled={!editGenerateQuery || isEstimating || isCostEstimated}
              btnclick={estimateCost}
              customstyle={{
                width: "160px",
                height: "45px",
                fontSize: "16px",
                borderRadius: "25px",
                margin: "5",
              }}
            />
          </Grid>
        }
        {!is
          <Grid item>
            <p style={{ fontSize: "15px", color: "black", margin: 12 }}>
              Estimated Cost:
              <span style={{ fontWeight: "bold" }}>$ {cost}</span>
            </p>
          </Grid>}
      </Grid> */}

      <Grid
        container
        direction="column"
        justifyContent="end"
        alignItems="flex-end"
        spacing={2}
        width={"100%"}
      // style={{
      //   width: "100%",
      // }}
      >
        {/* <Grid item sx={12}> */}
        <div style={{ minHeight: "5px", justifyContent: "end" }}>
          <QueryButton
            btntext={"Estimate Cost"}
            isDisabled={!editGenerateQuery || isEstimating || isCostEstimated}
            btnclick={estimateCost}
            customstyle={{
              width: "160px",
              height: "40px",
              fontSize: "15px",
              borderRadius: "25px",
              margin: "5px",
              cursor: !editGenerateQuery ? "not-allowed" : "pointer",
              background: !editGenerateQuery
                ? "#e8e8e8"
                : "linear-gradient(90deg, #4a5568 0%, #718096 93%)",
              color: !editGenerateQuery ? "#888888" : "#ffffff",
            }}
          />
        </div>
        <div style={{ minHeight: "60px", justifyContent: "start" }}>
          {isCostEstimated && (
            <Grid item>
              <p style={{ fontSize: "15px", color: "black", margin: 10 }}>
                Estimated Cost :
                <span style={{ fontWeight: "bold" }}> $ {cost}</span>
              </p>
            </Grid>
          )}
        </div>
        {/* </Grid> */}
      </Grid>

      {/* Display query and submit button */}
      <Grid
        container
        style={{
          width: "100%",
          height: "200px",
          justifyContent: "end",
        }}
        spacing={1}
      >
        <Grid size={{ xs: 2, md: 8, lg: 9 }}>
          {/* {!editGenerateQuery ? (
            <div className="maincontentinput" readOnly>
              <p>Generated query</p>
            </div>
          ) : ( */}
          <div className="textareacontainer">
            <textarea
              className="maincontentinput"
              value={editGenerateQuery}
              placeholder="Query"
              // readOnly={!editGenerateQuery}
              onChange={(e) => seteditGenerateQuery(e.target.value)}
            />
            <div className="copyicon" onClick={handleCopy}>
              <ContentCopyOutlinedIcon fontSize="small" />
            </div>
          </div>
          {/* )} */}
        </Grid>

        <Grid size={{ xs: 2, md: 8, lg: 3 }}>
          <div style={{ minHeight: "80px" }}>
            <QueryButton
              btntext={isGenerating ? CircularIndeterminate() : "Submit Query"}
              isDisabled={
                !getGenerateQueryMessage.query ||
                !isGenerating ||
                !editGenerateQuery
              }
              btnclick={() => submitQuery()}
              customstyle={{
                width: "100%",
                height: "55px",
                fontSize: "17px",
                borderRadius: "35px",
                color: !editGenerateQuery ? "#888888" : "#ffffff",
                cursor: !editGenerateQuery ? "not-allowed" : "pointer",
                background: !editGenerateQuery
                  ? "#e8e8e8"
                  : "linear-gradient(90deg, #4a5568 0%, #718096 93%)",
              }}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default MainContent;
